import { request } from "../base";

export type CommunicationLogEntry = {
	id: number;
	proId: string | null;
	userId: string | null;
	eventType: string;
	channel: string;
	recipient: string;
	actualRecipient: string | null;
	status: string;
	provider: string | null;
	environment: string | null;
	externalId: string | null;
	subject: string | null;
	contentSummary: string | null;
	previewHtml: string | null;
	previewText: string | null;
	transactional: boolean;
	errorMessage: string | null;
	metadataJson: string | null;
	dateCreated: string;
	dateUpdated: string | null;
};

type CommunicationListResponse = {
	items: CommunicationLogEntry[];
	total: number;
	limit: number;
	offset: number;
};

export const adminCommunicationsApi = {
	list(filters?: {
		channel?: string;
		status?: string;
		eventType?: string;
		environment?: string;
		search?: string;
		limit?: number;
		offset?: number;
	}) {
		const params = new URLSearchParams();
		if (filters?.channel) params.set("channel", filters.channel);
		if (filters?.status) params.set("status", filters.status);
		if (filters?.eventType) params.set("eventType", filters.eventType);
		if (filters?.environment) params.set("environment", filters.environment);
		if (filters?.search) params.set("search", filters.search);
		if (filters?.limit) params.set("limit", String(filters.limit));
		if (filters?.offset) params.set("offset", String(filters.offset));
		const qs = params.toString();
		return request<CommunicationListResponse>(
			`/api/admin/communications${qs ? `?${qs}` : ""}`,
		);
	},
	getById(id: number) {
		return request<CommunicationLogEntry>(`/api/admin/communications/${id}`);
	},
};
